module.exports = __webpack_public_path__ + "img/birthEngraving.8ec3038.webp";